import { useFormat } from '@ideavivat/vivat-2';
import {
  _primaryControls,
  _selectorControls,
  _increment,
  production_type,
  job_no,
  module_no,
  drawing_no,
  description,
  material_code,
  amount,
  withdrawn_amount,
  purchased_amount,
  unit,
  status,
  heat_treatment,
  surface_treatment,
  target_date,
  remarks,
  leadTime,
} from '@/table/Job/SubJob/base';
import useSubJob from '@/use/useSubJob';

const {
  translateSubJobStatus, statusClassMap,
} = useSubJob();

function getStatus(
  overallStatus: string,
  computedStatus: string,
  processStatus: string | null = null,
  assemblyStatus: string | null = null,
) {
  return computedStatus;
}

export default {
  types: {
    _primaryControls,
    _selectorControls,
    _increment,
    production_type,
    job_no,
    module_no,
    drawing_no,
    description,
    material_code,
    amount,
    withdrawn_amount,
    purchased_amount,
    unit,
    status: {
      ...status,
      filter: (val: string, row: any) => translateSubJobStatus(getStatus(row.item.status, row.item.computed_status, row.item.process_status, row.item.assembly_status)),
      class: {
        text: (val: string, row: any) => statusClassMap(getStatus(row.item.status, row.item.computed_status, row.item.process_status, row.item.assembly_status)),
      },
    },
    heat_treatment,
    surface_treatment,
    purchaseCreated: {
      name: 'วันที่เปิด PO',
      width: '7rem',
      filter: (val: any, row: any) => {
        const items = row.item.purchase_order_items.filter((item: any) => !(item.subType));
        if (items.length > 0) return items[0].created_at ? useFormat.date(items[0]?.created_at).displayShortThaiDate() : '';
        return '';
      },
      class: 'text-center',
    },
    purchaseTargetDate: {
      name: 'วันที่คาดว่าจะได้รับ',
      width: '7rem',
      filter: (val: any, row: any) => {
        const items = row.item.purchase_order_items.filter((item: any) => !(item.subType));
        if (items.length > 0) return items[0].target_date ? useFormat.date(items[0]?.target_date).displayShortThaiDate() : '';
        return '';
      },
      class: 'text-center',
    },
    target_date,
    remarks,
    leadTime,
  },
  sortable: [
    'production_type',
    'job_no',
    'module_no',
    'drawing_no',
    'description',
    'material_code',
    'amount',
    'withdrawn_amount',
    'purchased_amount',
    'unit',
    'status',
    'heat_treatment',
    'surface_treatment',
    'target_date',
  ],
};
